export default {
  companyUrl: 'https://dev.lwtears.com',
  digitalAssetsUrl: 'https://a-z-educator-content-qa.s3.amazonaws.com',
};
